import { useDocumentTitle } from '@/hooks';
import { WaitlistScreen } from '../components/waitlist-screen';

/**
 * Onde quem terminou o cadastro com a fila de espera ligada cai sempre que
 * loga de novo - o HomeRoute manda pra ca em vez do painel normal.
 */
export function WaitlistPage() {
  useDocumentTitle('Fila de espera');

  return (
    <div className="min-h-screen bg-background px-4 py-10">
      <WaitlistScreen />
    </div>
  );
}
